<template>
  <div class="edit-managed-by">
    <q-spinner v-show="loading" color="primary" size="2em" />

    <Grid
      v-show="!loading"
      gaf="column"
      align-items="center"
      gap="var(--r-space-sm)"
      class="text-body-1 text-secondary-1"
    >
      Managed by: {{ periodOwner }}
      <div>
        <EditIcon class="cursor-pointer" @click.native="editMode = true"></EditIcon>
        <RPopupEdit :value="ownerId" title="Edit subscription manager" @ok="onSave">
          <template v-slot="{ model, loading: isLoading }">
            <RDropdown
              v-model="model.value"
              :disable="isLoading"
              :options="users"
              emit-value
              map-options
              label="Select owner:"
              option-label="name"
              option-value="id"
              no-hint
              style="width: 235px"
            />
          </template>
        </RPopupEdit>
      </div>
    </Grid>
  </div>
</template>

<script>
import * as apiTo from '@api/api-routes'
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
// Components
import EditIcon from '@/ui/icons/EditIcon'
import RPopupEdit from '@/ui/RPopupEdit'

export default {
  components: {
    EditIcon,
    RPopupEdit
  },

  props: {
    subId: [Number, String],
    loading: Boolean
  },

  data: () => ({
    editMode: false,
    ownerId: null
  }),

  computed: {
    ...mapState('subscription-show', ['users']),
    ...mapGetters('subscription-show', ['periodId', 'subscriptionPeriods']),

    periodOwner() {
      if (!this.subscriptionPeriods) return
      const period = this.subscriptionPeriods.find(period => period.id === this.periodId)
      if (!period) return
      return period.owner.name
    }
  },

  watch: {
    periodId: 'setOwner',
    subscriptionPeriods: 'setOwner'
  },

  created() {
    if (!this.users) this.getAndSetUsers()
  },

  methods: {
    ...mapMutations('subscription-show', ['updatePeriod']),
    ...mapActions('subscription-show', ['fetchSubscription', 'getAndSetUsers']),

    setOwner() {
      this.editMode = false
      if (!this.subscriptionPeriods) return
      const period = this.subscriptionPeriods.find(period => period.id === this.periodId)
      if (period) this.ownerId = period.owner.id
    },

    onSave({ set, cancel, setLoading, value }) {
      setLoading(true)

      apiTo
        .updateSubscriptionPeriod(this.periodId, {
          owner_id: value
        })
        .then(({ data }) => {
          this.updatePeriod(data.result)
          this.fetchSubscription(this.subId)
          this.editMode = false
          set()
        })
        .catch(cancel)
        .finally(() => setLoading(false))
    }
  }
}
</script>

<style lang="stylus" scoped>
.edit-managed-by {
  .dropdown {
    width 350px
    display grid
    grid-template-columns 1fr auto auto
    align-items center
    gap 15px
    justify-content center
  }
}
</style>
